// Loop through the feedback blocks on the page
document.querySelectorAll( '.ofh-feedback' ).forEach( ( el ) => {

  // Loop through the buttons
  el.querySelectorAll( '.question-button' ).forEach( ( button ) => {

    // Add a click event listener
    button.addEventListener( 'click', ( event ) => {

      // Hide the question
      el.querySelector( '.feedback-question' ).style.display = 'none';

      // If it's the yes button
      if ( button.classList.contains( 'question-button-yes' ) ) {

        // Show the thanks message
        el.querySelector( '.feedback-yes' ).style.display = 'block';

      }

      // If it's the no button
      if ( button.classList.contains( 'question-button-no' ) ) {

        // Show the survey message
        el.querySelector( '.feedback-no' ).style.display = 'block';

      }

    } );

  } );

} );
